import { render, staticRenderFns } from "./AgencyListSummary.vue?vue&type=template&id=4a871788&scoped=true"
import script from "./AgencyListSummary.vue?vue&type=script&lang=js"
export * from "./AgencyListSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a871788",
  null
  
)

export default component.exports